module.exports = __webpack_public_path__ + "img/feedback-loop-mob.db1d2176.webp";